import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// oxlint-disable-next-line import/no-unassigned-import
import "@/index.css";
import App from "@/App.tsx";
import { IntlProvider } from "@/providers/intl.tsx";
import { TRPCProvider } from "@/providers/trpc.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <TRPCProvider>
      <IntlProvider>
        <App />
      </IntlProvider>
    </TRPCProvider>
  </StrictMode>,
);
